import request from '@/utils/request'
const apiPath = '/activity/goodsActivity'
import { downloadBlob } from '@/utils/download'
const sysGoodsApi = {
  /**
   * 新增【活动】
   */
  create(data) {
    // BUG-2026-994011：silent 让业务错误带着原始响应返回，活动表单的持续错误框才能显示真实原因
    return request.post(apiPath, data, { silent: true })
  },
  /**
   * 修改【活动】
   */
  update(data) {
    return request.put(apiPath, data, { silent: true })
  },
  /**
   * 分页查询【活动】
   */
  fetchList(query) {
    return request.get(apiPath, { params: query })
  },
  /**
   * 查询【活动】选项列表
   */
  findOptions(query) {
    return request.get(`${apiPath}/options`, { params: query })
  },
  /**
   * 查看【活动】详情
   */
  fetchById(id) {
    return request.get(`${apiPath}/${id}`)
  },
  /**
   * 删除单个【活动】
   */
  deleteById(id) {
    return request.delete(`${apiPath}/${id}`)
  },
  updateState(data) {
    return request.post(apiPath + '/updateState', data)
  },
  exportExcel(query) {
    return request.get(`${apiPath}/export`, { responseType: 'blob', params: query })
      .then(res => downloadBlob(res, '活动列表.xlsx'))
  },
}
export default sysGoodsApi
